/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { MergedIntoHistoryEntrySource } from './MergedIntoHistoryEntrySource';
import {
    MergedIntoHistoryEntrySourceFromJSON,
    MergedIntoHistoryEntrySourceFromJSONTyped,
    MergedIntoHistoryEntrySourceToJSON,
    MergedIntoHistoryEntrySourceToJSONTyped,
} from './MergedIntoHistoryEntrySource';
import type { MergedIntoHistoryEntryMergedBy } from './MergedIntoHistoryEntryMergedBy';
import {
    MergedIntoHistoryEntryMergedByFromJSON,
    MergedIntoHistoryEntryMergedByFromJSONTyped,
    MergedIntoHistoryEntryMergedByToJSON,
    MergedIntoHistoryEntryMergedByToJSONTyped,
} from './MergedIntoHistoryEntryMergedBy';

/**
 * 
 * @export
 * @interface MergedIntoHistoryEntry
 */
export interface MergedIntoHistoryEntry {
    /**
     * 
     */
    source: MergedIntoHistoryEntrySource;
    /**
     * When the source was merged, which is when it was soft-deleted
     */
    merged_at: Date;
    /**
     * 
     */
    merged_by?: MergedIntoHistoryEntryMergedBy;
}

/**
 * Check if a given object implements the MergedIntoHistoryEntry interface.
 */
export function instanceOfMergedIntoHistoryEntry(value: object): value is MergedIntoHistoryEntry {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('merged_at' in value) || value['merged_at'] === undefined) return false;
    return true;
}

export function MergedIntoHistoryEntryFromJSON(json: any): MergedIntoHistoryEntry {
    return MergedIntoHistoryEntryFromJSONTyped(json, false);
}

export function MergedIntoHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedIntoHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'source': MergedIntoHistoryEntrySourceFromJSON(json['source']),
        'merged_at': (json['merged_at'] == null ? json['merged_at'] : parseDateTime(json['merged_at'])),
        'merged_by': json['merged_by'] == null ? undefined : MergedIntoHistoryEntryMergedByFromJSON(json['merged_by']),
    };
}

export function MergedIntoHistoryEntryToJSON(json: any): MergedIntoHistoryEntry {
    return MergedIntoHistoryEntryToJSONTyped(json, false);
}

export function MergedIntoHistoryEntryToJSONTyped(value?: MergedIntoHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': MergedIntoHistoryEntrySourceToJSON(value['source']),
        'merged_at': value['merged_at'] == null ? value['merged_at'] : serializeDateTime(value['merged_at']),
        'merged_by': MergedIntoHistoryEntryMergedByToJSON(value['merged_by']),
    };
}

